<template>
  <div class="animated fadeIn">
    <b-col>
      <b-card>
      <b-row class="text-center">
        <b-col sm="4">
          <span>Last System Pattern</span>
        </b-col>
        <b-col sm="4">
          <span v-if="pattern" >{{ pattern.created_at | datetime}}</span>
          <span v-else >-</span>
        </b-col>
        <b-col sm="4">
          <span v-if="pattern" >{{ codes.WMDS_TYPE[pattern.type || ''] }}</span>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center">
        <b-col sm="12">
          <span v-if="pattern" >{{ pattern.code | truncate(50) }}</span>
          <span v-else >-</span>
        </b-col>
      </b-row>
    </b-card>
      <b-row>
        <b-col md="6">
          <b-card header="Detect">
            <template slot="header">
              <i class='fa fa-align-justify'></i> Detect
              <hr>
              <b-col sm="12">
                <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
                  Real-time
                  <select v-model="detect.interval" @change="refresh('detect')">
                    <option disabled value="15">Please select interval : Default 15</option>
                    <option value=10>10</option>
                    <option value=30>30</option>
                    <option value=60>60</option>
                    <option value=300>300(5 min)</option>
                  </select>
                  sec
                </span>
                <span class="float-right">
                  <i :class="`fa fa-refresh ${detect.th && !detect.stop ? 'fa-spin' : ''}`"></i>
                  <b-btn @click="pause('detect')" size="sm" variant="warning">Pause</b-btn>
                </span>
              </b-col>
              <hr>
              <b-col sm="12">
                Show count
                <select v-model="model.detect.so.limit" @change="refresh('detect')">
                  <option disabled value="15">Default 15</option>
                  <option value=10>10</option>
                  <option value=50>50</option>
                  <option value=100>100</option>
                </select>
              </b-col>
            </template>
            <b-table hover striped small responsive="sm" foot-clone ref="_list_detect"
              show-empty empty-text="There is no history of Detect!" :tbody-tr-class="rowHighlight"
              :items="getDetect" :fields="f_detect" :current-page="so.currentPage" :per-page="model.result.so.limit" :sortBy="so.sk">
              <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
              <template slot="domain" slot-scope="row">{{row.item.domain }}</template>
              <template slot="type" slot-scope="row">
                {{codes.WMDS_TYPE[row.item.type]}}
              </template>
              <template slot="func" slot-scope="row">
                <b-btn @click="$router.push(`detect/${row.item.id}`)" size="sm" variant="warning">More</b-btn>
              </template>
            </b-table>
            <b-button class="float-right" size="sm" variant="primary" @click="$router.push(`detect`)"> List </b-button>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card>
            <template slot="header">
              <i class='fa fa-align-justify'></i> Result
              <hr>
              <b-col sm="12">
                <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
                  Real-time
                  <select v-model="result.interval" @change="refresh('result')">
                    <option disabled value="15">Please select interval : Default 15</option>
                    <option value=10>10</option>
                    <option value=30>30</option>
                    <option value=60>60</option>
                    <option value=300>300(5 min)</option>
                  </select>
                  sec
                </span>
                <span class="float-right">
                  <i :class="`fa fa-refresh ${result.th && !result.stop ? 'fa-spin' : ''}`"></i>
                  <b-btn @click="pause('result')" size="sm" variant="warning">Pause</b-btn>
                </span>
              </b-col>
              <hr>
              <b-col sm="12">
                Show count
                <select v-model="model.result.so.limit" @change="refresh('result')">
                  <option disabled value="15">Default 15</option>
                  <option value=10>10</option>
                  <option value=50>50</option>
                  <option value=100>100</option>
                </select>
              </b-col>
            </template>
            <b-table hover striped small responsive="sm" foot-clone ref="_list_result"
                show-empty empty-text="There is no history of Result!" :tbody-tr-class="rowHighlight"
                :items="getResult" :fields="f_result" :current-page="so.currentPage" :per-page="model.result.so.limit" :sortBy="so.sk">
              <template slot="finished_at" slot-scope="row">{{ row.item.finished_at | datetime}}</template>
              <template slot="fqdn" slot-scope="row">{{row.item.site.fqdn}}</template>
              <template slot="count" slot-scope="row">
                {{row.item.page_count|number}} / {{row.item.ext_count|number}} / {{row.item.detect_count|number}} / {{row.item.binary_coount|number}} / {{row.item.error_count|number}}
              </template>
            </b-table>
            <b-button class="float-right" size="sm" variant="primary" @click="$router.push(`result`)"> List </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';


export default {
  computed : {
    f_detect : function() {
      return [
        { key: 'created_at', label: 'Detect_at', sortable: false, thStyle: 'width: 15%' },
        { key: 'domain', label: 'Site', sortable: false, thStyle: 'width: 15%' },
        { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 25%' },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
    f_result() { return [
        { key: 'finished_at', label: 'Finished_at', sortable: false, thStyle: 'width: 15%' },
        { key: 'fqdn', label: 'FQDN', sortable: false, thStyle: 'width: 15%' },
        { key: 'count', label: 'Count(Pages, External, Detect, Binary, Error)', sortable: false, thStyle: 'width: 25%' },
      ]
    },
  },
  data : () => {
    return {
      codes,
      sync : { th : undefined, stop : false, interval : 15 },
      detect : {},
      result : {},
      pattern : {},
      model : { result : { so : undefined, rows : [] }, detect : { so : undefined, rows : [] } },
      so : { offset : 0, currentPage : 1, target : '', cmd : '', totalRows : 0, limit : 15, body : { and : [], sort : [{ name : "id", op : "desc" } ], columns : [] }, },
    }
  },
  methods: {
    refresh(t = '') {
      location.hostname == 'localhost' ? console.log(t, this.result.th, this.detect.th) : '';
      if(t === '') {
        if(!this.result.th) { this.result.th = setTimeout(() => this.refresh('result'), this.result.interval * 1000); }
        if(!this.detect.th) { this.detect.th = setTimeout(() => this.refresh('detect'), this.detect.interval * 1000); }
      } else if(t == 'result') {
        if(!this.result.stop && this.$refs._list_result) { this.$refs._list_result.refresh(); }
        if(this.result.th) {  clearTimeout(this.result.th); this.result.th = undefined }
        this.result.th = setTimeout(() => this.refresh('result'), this.result.interval * 1000)
      } else {
        if(!this.detect.stop && this.$refs._list_detect) { this.$refs._list_detect.refresh(); }
        if(this.detect.th) { clearTimeout(this.detect.th); this.detect.th = undefined }
        this.detect.th = setTimeout(() => this.refresh('detect'), this.detect.interval * 1000)
      }
      console.log("request refresh", t == '' ? "init" : t)
      // interval 15 secs
    },
    pause(rs) {
      if(rs == 'result')
      {
        this.result.stop = !this.result.stop;
        console.log("refresh", "result", this.result.stop ? 'update.stop' : 'update.continue');
      } else {
        this.detect.stop = !this.detect.stop;
        console.log("refresh", "detect", this.detect.stop ? 'update.stop' : 'update.continue');
      }
      this.refresh(rs)

    },
    rowHighlight(item) {
      if (!item || !item.level) return '';
      if (item.detect_count > 0) return 'table-danger';

      switch (codes.WMDS_TYPE[item.level]) {
        case 'danger' : return 'table-danger';
        case 'warning' :
        case 'suspicion' :
        case 'caution' : return 'table-warning';
        default : return '';
      }
    },
    getPattern() {
      // recent system pattern
      let so = Object.assign({}, this.so, { target : 'wmds.pattern', cmd : 'list', offset : 0, limit : 1, body : {
        columns : ["code", "type", "created_at"]
      } })
      Api.Manager(so).then(rs => { this.pattern = rs.body ? rs.body[0] : ''; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    getDetect() {
      // detect
      let so = Object.assign({}, this.model.detect.so, { target : 'wmds.detect', cmd : 'list' })
      so.body.columns = ["id", "domain", "level", "type", "created_at"]
      return Api.Manager(so).then(rs => {
        this.model.detect.so.totalRows = rs.total;
        location.hostname == 'localhost' ? console.log("refresh detect done") : '';
        return rs.body
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    getResult() {
      // result
      let so = Object.assign({}, this.model.result.so, { target : 'wmds.result', cmd : 'list' })
      so.body.columns = ["id", "page_count", "detect_count", "ext_count", "error_count", "binary_count", "resource_count",  "created_at"]
      return Api.Manager(so).then(rs => {
        this.model.result.so.totalRows = rs.total;
        location.hostname == 'localhost' ? console.log("refresh result done") : '';
        return rs.body
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
  },
  created: function() {
    this.model.result.so =  Object.assign({}, this.so);
    this.model.detect.so =  Object.assign({}, this.so);
    this.result = Object.assign({}, this.sync);
    this.detect = Object.assign({}, this.sync);
    console.log('dashboard.vue', 'created');

  },
  destroyed: function() {
    clearTimeout(this.result.th);
    this.result.th = undefined;
    clearTimeout(this.detect.th);
    this.detect.th = undefined;
    console.log('dashboard.vue', 'destroyed');
  },
  mounted: function() { console.log('dashboard.vue', 'mounted'); this.getPattern(); this.refresh(''); },
}
</script>
